import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { RunStatus } from "@/api/types";

const STYLES: Record<RunStatus, string> = {
  pending: "bg-muted text-muted-foreground border-border",
  running:
    "bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/40",
  idle:
    "bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-500/40",
  stopped:
    "bg-zinc-500/15 text-zinc-700 dark:text-zinc-300 border-zinc-500/40",
  failed:
    "bg-red-500/15 text-red-700 dark:text-red-300 border-red-500/40",
};

export function RunStatusBadge({ status }: { status: RunStatus }) {
  const showDot = status === "running" || status === "idle";
  return (
    <Badge variant="outline" className={cn("gap-1.5 font-medium", STYLES[status])}>
      {showDot && (
        <span
          className={cn(
            "h-1.5 w-1.5 rounded-full",
            status === "running" ? "bg-blue-500 animate-pulse" : "bg-emerald-500",
          )}
          aria-hidden
        />
      )}
      {status}
    </Badge>
  );
}
